module.exports = __webpack_public_path__ + "img/fish.ec738724.jpg";